module.exports = __webpack_public_path__ + "img/Leo.e409beb7.svg";